import React from 'react';
import { Grid } from '@mui/material';


function MatrixDriverVendor(props) {
  const { matrix } = props;
  // Get the current URL pathname
  const currentPathname = window.location.pathname;

  // Extract the last name from the URL pathname
  const pathnameParts = currentPathname.split('/');
  const lastName = pathnameParts[pathnameParts.length - 1];

  // Define the desired last name
  const desiredLastName = 'detail';
  // Check if the last name matches the desired last name
  const isDesiredLastName = lastName === desiredLastName;
  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        columnGap={2}
        className={isDesiredLastName ? 'displayNone' : "displayBlock"}
      >
        <Grid item>
          <h1 className="font16 fontBold">Monthly Matrix</h1>
        </Grid>
      </Grid>

      <Grid
        container
        direction='row'
        justifyContent='start'
        alignItems='center'
        className='matrixAlign'
        rowSpacing={2}

      >
        {matrix && matrix.map((document) => (
          <Grid
            item
            container
            spacing={2}
            md={3.5}
            sm={4.7}
            xs={12}
            direction='row'
            alignItems='center'
            justifyItems='center'
            className="boxShadow"
            key={document.id}
          >
            <Grid item>
              <img src={document.icon} alt="wallet" />
            </Grid>
            <Grid item className='cardAlign'>
              <p className="marginBlock10 font28 colorBlue fontMedium">{document.amt}</p>
              <p className="marginBlock10 font20 colorBlack fontMedium"> {document.name}</p>
            </Grid>
          </Grid>

        ))}

      </Grid>


    </div>
  );
}

export default MatrixDriverVendor;
